import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useGiftMessageForm } from 'lib/core/hooks'
import { GiftMessageForm } from './components/GiftMessageForm'
import { IndividualItem } from './components/IndividualItem'
import { Container, AddGiftMessageContainer, EntireOrderContainer, IndividualItemsContainer } from './styled'

export const GiftMessage = () => {
  const {
    isLoading,
    addGiftMessage,
    setAddGiftMessage,
    addIndividually,
    setAddIndividually,
    addEntireOrder,
    setAddEntireOrder,
    data,
    setData,
    cartItems,
    hasItems
  } = useGiftMessageForm()

  if (!hasItems) {
    return null
  }

  if (isLoading) {
    return (
      <div>
        <FormattedMessage id='app.loading' />
      </div>
    )
  }

  return (
    <Container>
      <div>
        <label>
          <input
            checked={addGiftMessage}
            type='checkbox'
            onChange={(e) => {
              setAddGiftMessage(e.target.checked)
            }}
          />
          {' '}
          <span>
            <FormattedMessage id='giftMessage.action.add' />
          </span>
        </label>
      </div>

      {addGiftMessage && (
        <AddGiftMessageContainer>
          <EntireOrderContainer>
            <div>
              <label>
                <input
                  checked={addEntireOrder}
                  type='checkbox'
                  onChange={(e) => {
                    setAddEntireOrder(e.target.checked)
                  }}
                />
                {' '}
                <span>
                  <FormattedMessage id='giftMessage.action.addToOrder' />
                </span>
              </label>
            </div>
            {addEntireOrder && (
              <GiftMessageForm
                initialValues={data.order}
                onSubmit={(values) => {
                  setData(state => ({
                    ...state,
                    order: values
                  }))
                }}
              />
            )}
          </EntireOrderContainer>

          <IndividualItemsContainer>
            <div>
              <label>
                <input
                  checked={addIndividually}
                  type='checkbox'
                  onChange={(e) => {
                    setAddIndividually(e.target.checked)
                  }}
                />
                {' '}
                <span>
                  <FormattedMessage id='giftMessage.action.addToItems' />
                </span>
              </label>
            </div>
            {addIndividually && (
              <>
                {cartItems.map(item => {
                  return (
                    <IndividualItem
                      key={item.id}
                      item={item}
                      initialValues={data.items?.[item.id]}
                      onSubmit={(values) => {
                        setData(state => ({
                          ...state,
                          items: {
                            ...state.items,
                            [item.id]: values
                          }
                        }))
                      }}
                    />
                  )
                })}
              </>
            )}
          </IndividualItemsContainer>
        </AddGiftMessageContainer>
      )}
    </Container>
  )
}
